import React, { Component } from 'react'
import { Row, Col, Input } from "reactstrap"
import { debounce } from 'lodash'
import AdvancedFiltersControl from '../../Filters/AdvancedFiltersControl'
import AppliedAdvancedFilters from '../../Filters/AppliedAdvancedFilters'

class CarInspectionsListHeader extends Component {
    // Debounced so typing doesn't refire the list query on every keystroke.
    updateSearchTerm = debounce((searchTerm) => {
        this.props.setFilterValues({ ...this.props.filterValues, searchTerm })
    }, 1000)

    componentWillUnmount() {
        this.updateSearchTerm.cancel()
    }

    render() {
        return (
            <Row className="pb-2 align-items-center">
                <Col xs={4}>
                    <span className="driver-search-filter">
                        <Input type="text" name="searchTerm" placeholder="Search ID, car, driver, VIN or plate" onChange={(e) => this.updateSearchTerm(e.target.value)} />
                        <i className="fa fa-lg fa-search search-icon" aria-hidden="true"></i>
                    </span>
                </Col>
                <Col xs="auto" className="p-0">
                    <AdvancedFiltersControl entity="car_condition" />
                </Col>
                <Col />
                <Col xs={12} className="mt-2 search-filter-container">
                    <AppliedAdvancedFilters entity="car_condition" context={null} />
                </Col>
            </Row>
        )
    }
}

export default CarInspectionsListHeader
